module.exports = __webpack_public_path__ + "img/logo-kakao-vx-foot@2x.82fd2a2c.png";